import {  useGetCollectorLogsQuery } from "../collector";
import { useParams } from "react-router-dom";
import CommonHistoryForm from "../../../../components/common/CommonHistoryGrid/CommonHistoryGrid";
import { skipToken } from "@reduxjs/toolkit/query";

const CollectorHistoryForm = () => {

    const { collectorId } = useParams();

    const {
        data: logsData,
        isLoading: loading,
        isError: error,
    } = useGetCollectorLogsQuery(collectorId || skipToken);

    return (
        <CommonHistoryForm
        data={logsData}
        title="Collector History"
        count={logsData?.length || 0}
        hasAddPermission={true}
        hasSortPermission={true}
      />
    );
};

export default CollectorHistoryForm;
